var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteIconOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.588,
    height: 17.588,
    viewBox: "0 0 17.588 17.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    width: 17.588,
    height: 17.588,
    fill: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3488",
    "data-name": "Group 3488",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3325",
    "data-name": "Group 3325",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M15.112,17.588H2.477A2.479,2.479,0,0,1,0,15.112V2.476A2.48,2.48,0,0,1,2.477,0H15.112a2.48,2.48,0,0,1,2.477,2.476V15.112a2.479,2.479,0,0,1-2.477,2.476M6.757,16.247h8.354a1.137,1.137,0,0,0,1.135-1.135V6.757H6.757ZM1.342,6.757v8.354a1.137,1.137,0,0,0,1.135,1.135H5.416V6.757ZM6.757,5.416h9.49V2.476a1.136,1.136,0,0,0-1.135-1.135H6.757Zm-5.416,0H5.416V1.342H2.477A1.136,1.136,0,0,0,1.342,2.476Z",
    transform: "translate(0 0)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIconOrder);
export default __webpack_public_path__ + "static/media/quote-icon-order.fcde2e8a7e394dcd549605de105db20b.svg";
export { ForwardRef as ReactComponent };